import { ContentContainer } from '~/components/container';

export function SectionBar() {
  return (
    <ContentContainer
      _after={{
        content: "''",
        display: 'block',
        width: '100%',
        height: '1px',
        backgroundColor: 'supportBlue.30',
      }}
      _last={{
        display: 'none',
      }}
    />
  );
}
